import { fetchBaseQuery } from "@reduxjs/toolkit/query"
import { createApi } from "@reduxjs/toolkit/query/react"

interface LoginRequest {
  userName: string
  password: string
}

interface LoginResponse {
  token: string
  refreshToken: string
  tokenExpiration: string
  refreshTokenExpiration: string
}

const baseQuery = fetchBaseQuery({ baseUrl: `${process.env.REACT_APP_API_BASE_URL}/Auth` })

export const adminAuthApi = createApi({
  reducerPath: "adminAuthApi",
  keepUnusedDataFor: 0,
  baseQuery,
  endpoints: (builder) => ({
    login: builder.mutation<LoginResponse, LoginRequest>({
      query: (credentials) => ({
        url: "/login",
        method: "POST",
        body: credentials,
      }),
    }),
  }),
})

export const { useLoginMutation } = adminAuthApi

